import { Component, computed, inject, signal } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { TranslateModule } from "@ngx-translate/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CardModalService } from "@shared/card-modal";
import { DashboardsService } from "@shared/index";
import { ApplicationType } from "@app/views-interfaces";

@Component({
    selector: "wk-ifirm-notes-panel",
    imports: [JumpstartComponentsModule, TranslateModule, ReactiveFormsModule],
    templateUrl: "./ifirm-notes-panel.component.html",
    styleUrl: "./ifirm-notes-panel.component.scss",
})
export class iFirmNotesPanelComponent {
    protected readonly dashboardsService = inject(DashboardsService);
    protected readonly cardModalService = inject(CardModalService);

    protected currentTabId = signal<string>("Notes");

    protected title = computed<string>(() => {
        const currentDashboard = this.dashboardsService.currentDashboard();
        switch (currentDashboard?.ApplicationType) {
            case ApplicationType.JobsBilling:
                return "JobsAndBilling.Notes.Title";
            default:
                return "CardModal.IFirmTaxNote";
        }
    });

    protected field = computed<string>(() => {
        const currentDashboard = this.dashboardsService.currentDashboard();
        switch (currentDashboard?.ApplicationType) {
            case ApplicationType.JobsBilling:
                return "note";
            default:
                return "temporaryNote";
        }
    });

    protected type = computed<string>(() => {
        const currentDashboard = this.dashboardsService.currentDashboard();
        switch (currentDashboard?.ApplicationType) {
            case ApplicationType.JobsBilling:
                return "job";
            default:
                return "ifirm";
        }
    });

    protected onTabSelect(tab: string): void {
        this.currentTabId.set(tab);
    }
}
